import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {fetchDataFx, commonData$, ReceiptsDetailGate} from './index';

commonData$.on(fetchDataFx.done, (state, {result}) => result).reset(ReceiptsDetailGate.close);

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));

sample({
    clock: ReceiptsDetailGate.open,
    source: ReceiptsDetailGate.state,
    fn: (state) => state.id,
    target: fetchDataFx,
});
